import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Footer from './components/footer/Footer';
import styled from 'styled-components';
import Header from './components/header/Header';
import { AuthProvider } from './provider/AuthProvider';
import PrivateRoute from './utils/PrivateRoute';

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid red;
`


function App() {
  return (
    <AuthProvider>
      <Wrapper>
        <Header />
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="login" element={<Login />} />
            <Route path="dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </Wrapper>
    </AuthProvider>
  );
}

export default App;
